'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var Paragraph = require('@narvar/nth-bit-paragraph');
var Divider = require('@narvar/nth-bit-divider');
var TextInput = require('@narvar/nth-block-text-input');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var styles = require('./styles.js');
var Items = require('./Items.js');
var Total = require('./Total.js');
var index$3 = require('../../components/Language/index.js');
var index$5 = require('../../components/Spinner/index.js');
require('../../components/Button/styles.js');
require('@babel/runtime/helpers/extends');
var index$6 = require('../../components/LocationCard/index.js');
require('../../components/PudoCard/index.js');
require('../../components/ItemCard/index.js');
require('../../components/SelectItem/index.js');
require('../../components/SelectList/index.js');
var index$2 = require('../../components/ErrorBanner/index.js');
var index$1 = require('../../components/Footer/index.js');
var index = require('../../components/StickyFooter/index.js');
require('../../components/SwatchesList/index.js');
require('@narvar/nth-bit-text-link');
var index$4 = require('../../components/Backdrop/index.js');
require('../../components/LineItemsGroup/index.js');
var ItemCardSkeleton = require('../../components/Skeleton/ItemCardSkeleton.js');
var LineItemSkeleton = require('../../components/Skeleton/LineItemSkeleton.js');
require('../../components/Skeleton/PudoCardSkeleton.js');
var Checkbox = require('@narvar/nth-block-checkbox');
var useLanguage = require('../../hooks/useLanguage.js');
var ReturnsConfigProvider = require('../../providers/ReturnsConfigProvider.js');
var validateString = require('../../utils/validateString.js');
require('@babel/runtime/helpers/defineProperty');
require('escape-string-regexp');
var index$7 = require('./ReshopOptIn/index.js');
var StyledThemeProvider = require('../../providers/StyledThemeProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);
var Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(Checkbox);

const HIPAA_CSR_ROLES = ['csrHipaa', 'csrAdminHipaa'];
const checkIfEmailFieldIsValid = function () {
  let email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let options = arguments.length > 1 ? arguments[1] : undefined;
  const {
    canAddCustomerEmail,
    canUpdateCustomerEmailHipaa,
    hasAssociatedEmail
  } = options || {};
  const isValidEmail = validateString.validatePattern(email, validateString.EMAIL_ADDRESS_PATTERN);
  if (!canAddCustomerEmail && !canUpdateCustomerEmailHipaa) {
    // The check for email state validity is true if the user can't update the email in any way, therefore there is no email field to validate.
    return true;
  }
  if (canAddCustomerEmail && isValidEmail && !canUpdateCustomerEmailHipaa) {
    // The shopify user canAddCustomerEmail, and the entered email is valid
    return true;
  }
  if (canUpdateCustomerEmailHipaa && !hasAssociatedEmail && isValidEmail && !canAddCustomerEmail) {
    // The HIPAA user canUpdateCustomerEmailHipaa, the order DOES NOT have an email to begin with, and the entered email is valid.
    return true;
  }
  if (canUpdateCustomerEmailHipaa && hasAssociatedEmail && (isValidEmail || email === '')) {
    // The HIPAA user canUpdateCustomerEmailHipaa, the order has an email to begin with, and the newly entered email is valid OR the email field is empty.
    return true;
  }
  return false;
};
const ReviewSummaryContent = _ref => {
  let {
    canAddCustomerEmail,
    canUpdateCustomerEmailHipaa,
    locale,
    includeCurrency,
    orderItems,
    selectedItems,
    dropOffLocation,
    fees,
    refund,
    error,
    hasAssociatedEmail,
    loading,
    mailTo,
    renderAddOn,
    onEmailChange,
    policyChecked,
    policyLabel,
    onPolicyChange,
    type,
    preferencesStatus,
    savePreferences,
    onSavePreferencesChange,
    reshopOptions,
    onReshopOptionsChange
  } = _ref;
  const {
    itemDisplay
  } = nthHookSettings.useSettings();
  const {
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  const returnsReviewAddEmailInputLabel = useLanguage["default"]({
    langKey: 'returnsReviewAddEmailInputLabel',
    asString: true
  }).value;
  if (loading) {
    return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(ItemCardSkeleton.ItemCardSkeleton, null), /*#__PURE__*/React__default["default"].createElement(LineItemSkeleton.LineItemSkeleton, null), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), /*#__PURE__*/React__default["default"].createElement(LineItemSkeleton.LineItemSkeleton, null), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), /*#__PURE__*/React__default["default"].createElement(LineItemSkeleton.LineItemSkeleton, null), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), /*#__PURE__*/React__default["default"].createElement(LineItemSkeleton.LineItemSkeleton, null), /*#__PURE__*/React__default["default"].createElement(ItemCardSkeleton.ItemCardSkeleton, null));
  }
  const hasExchange = selectedItems.some(item => item.exchangeTo);
  const hasReturn = selectedItems.some(item => !item.exchangeTo);
  const handlePolicyChange = event => {
    onPolicyChange === null || onPolicyChange === void 0 ? void 0 : onPolicyChange(Boolean(event.target.checked));
  };
  const handleInputChange = event => {
    onEmailChange === null || onEmailChange === void 0 ? void 0 : onEmailChange(event.target.value);
  };
  const handleSavePreferencesChange = event => {
    onSavePreferencesChange === null || onSavePreferencesChange === void 0 ? void 0 : onSavePreferencesChange(Boolean(event.target.checked));
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      ...bodytextDefaultNone
    }
  }, /*#__PURE__*/React__default["default"].createElement(styles.StyledHeaderContainer, null, error && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      marginBottom: '1rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(index$2["default"], null, /*#__PURE__*/React__default["default"].isValidElement(error) ? error : /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
    langKey: "returnsReviewError"
  }))), /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, null, /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
    langKey: "returnsReviewHeader"
  })), /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
    langKey: `returnsReviewDescription${type ?? ''}`
  }))), /*#__PURE__*/React__default["default"].createElement(styles.StyledMain, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
    langKey: hasExchange && hasReturn ? 'returnsReviewSubHeaderReturnAndExchange' : hasExchange ? 'returnsReviewSubHeaderExchange' : 'returnsReviewSubHeader'
  })), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), /*#__PURE__*/React__default["default"].createElement(Items.Items, {
    orderItems,
    selectedItems,
    locale,
    includeCurrency,
    itemDisplay: itemDisplay
  }), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), /*#__PURE__*/React__default["default"].createElement(Total.Total, {
    items: selectedItems,
    fees: fees,
    refund: refund,
    locale: locale,
    includeCurrency: includeCurrency
  })), dropOffLocation && /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
    langKey: "returnsReviewDropOffLocationHeader"
  })), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), /*#__PURE__*/React__default["default"].createElement(index$6["default"], {
    location: dropOffLocation,
    active: true,
    transparent: true
  })), /*#__PURE__*/React__default["default"].createElement(styles.StyledConditionalSections, null, canUpdateCustomerEmailHipaa && /*#__PURE__*/React__default["default"].createElement(styles.StyledAddEmailToReturn, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
    langKey: "returnsReviewAddEmailHeader"
  })), /*#__PURE__*/React__default["default"].createElement(styles.StyledParagraph, null, /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
    langKey: hasAssociatedEmail ? 'returnsReviewUpdateEmailDescription' : 'returnsReviewAddEmailDescription'
  })), /*#__PURE__*/React__default["default"].createElement(TextInput__default["default"], {
    id: "customerEmail",
    type: TextInput.SupportedInputType.email,
    label: returnsReviewAddEmailInputLabel,
    animateLabel: true,
    value: mailTo,
    onChange: handleInputChange,
    containerOverridesStyle: {
      background: '#fff'
    }
  })), /*#__PURE__*/React__default["default"].isValidElement(renderAddOn) ? renderAddOn : typeof renderAddOn === 'function' ? renderAddOn() : null, policyLabel && /*#__PURE__*/React__default["default"].createElement(Checkbox__default["default"], {
    checked: policyChecked,
    id: 'policyCheckbox',
    onChange: handlePolicyChange
  }, policyLabel), preferencesStatus && !preferencesStatus.profileStatus && /*#__PURE__*/React__default["default"].createElement(styles.StyledSavePreferences, null, /*#__PURE__*/React__default["default"].createElement(Checkbox__default["default"], {
    id: "savePreferencesCheckbox",
    checked: savePreferences,
    onChange: handleSavePreferencesChange
  }, /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
    langKey: "returnsReviewPreferencesCheckboxLabel"
  })), canAddCustomerEmail && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
    langKey: "returnsReviewPreferencesInputLabel"
  }), /*#__PURE__*/React__default["default"].createElement(styles.StyledPreferencesEmail, {
    id: "customerEmail",
    type: TextInput.SupportedInputType.email,
    value: mailTo,
    onChange: handleInputChange
  }))), reshopOptions && /*#__PURE__*/React__default["default"].createElement(index$7["default"], {
    value: reshopOptions,
    error: reshopOptions.error,
    onChange: onReshopOptionsChange
  })));
};
const ReviewSummaryRawC = _ref2 => {
  let {
    locale,
    includeCurrency,
    orderItems,
    selectedItems,
    fees,
    refund,
    dropOffLocation,
    hasAssociatedEmail,
    error,
    loading,
    disabled,
    allowRetry,
    submitting,
    returnCart,
    mailTo,
    onBack,
    onSubmit,
    renderAddOn: renderAddOn,
    policyChecked,
    policyLabel,
    preferencesStatus,
    savePreferences,
    onChange,
    progressiveStep,
    activeStep,
    userRole,
    reshopOptions
  } = _ref2;
  const {
    isHipaaCompliant
  } = ReturnsConfigProvider.useReturnsConfig();

  // Shopify customers without an associated email and who can save preferences.
  const canAddCustomerEmail = !isHipaaCompliant && !hasAssociatedEmail && savePreferences;

  // Using isHipaaCompliant below is repetitive, but is an extra safety check.
  // Hipaa CSRs can update email
  const canUpdateCustomerEmailHipaa = isHipaaCompliant && HIPAA_CSR_ROLES.includes(userRole ?? '');
  const backLabel = useLanguage["default"]({
    langKey: 'returnsActionsBack',
    asString: true
  }).value;
  const submitLabel = useLanguage["default"]({
    langKey: 'returnsActionsSubmit',
    asString: true
  }).value;
  const [errorPosition, setErrorPosition] = React.useState('inline');
  const handleFooterEvent = event => {
    if (event.value === 'back') {
      onBack === null || onBack === void 0 ? void 0 : onBack({
        value: {},
        area: 'returnReview',
        event: 'back'
      });
    }
    if (event.value === 'submit') {
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
        value: {},
        area: 'returnReview',
        event: 'submit'
      });
    }
  };
  const handlePolicyChange = event => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      area: 'returnReview',
      event: 'change',
      value: {
        policyChecked: event
      },
      subComponent: 'policyCheckbox'
    });
  };
  const handleEmailChange = event => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      area: 'returnReview',
      event: 'change',
      value: {
        mailTo: event
      },
      subComponent: 'mailToInput'
    });
  };
  const handleSavePreferencesChange = event => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      area: 'returnReview',
      event: 'change',
      value: {
        savePreferences: event
      },
      subComponent: 'savePreferences'
    });
  };
  const handleReshopOptionsChange = event => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      area: 'returnReview',
      event: 'change',
      value: {
        reshopOptions: event
      },
      subComponent: 'reshopOptions'
    });
  };
  const handleOnFooterShow = event => {
    setErrorPosition(event.inView && event.display === 'inline' ? 'footer' : 'inline');
  };
  const isEmailFieldStateValid = checkIfEmailFieldIsValid(mailTo, {
    canAddCustomerEmail,
    canUpdateCustomerEmailHipaa,
    hasAssociatedEmail
  });
  const submitEnabled = [isEmailFieldStateValid, policyLabel ? policyChecked : true, !loading, !submitting, !error || allowRetry, !disabled].every(Boolean);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(styles.StyledReviewSummaryContainer, null, /*#__PURE__*/React__default["default"].createElement(ReviewSummaryContent, {
    canAddCustomerEmail,
    canUpdateCustomerEmailHipaa,
    locale,
    includeCurrency,
    orderItems,
    selectedItems,
    fees,
    refund,
    dropOffLocation,
    error: errorPosition === 'inline' ? error : null,
    hasAssociatedEmail,
    loading,
    mailTo,
    renderAddOn: renderAddOn,
    onEmailChange: handleEmailChange,
    policyChecked,
    policyLabel,
    onPolicyChange: handlePolicyChange,
    preferencesStatus,
    savePreferences,
    onSavePreferencesChange: handleSavePreferencesChange,
    userRole,
    reshopOptions,
    onReshopOptionsChange: handleReshopOptionsChange
  })), !loading && !submitting && (returnCart === null || returnCart === void 0 ? void 0 : returnCart.pudoOption) && /*#__PURE__*/React__default["default"].createElement(index["default"], {
    onShow: handleOnFooterShow
  }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    progressiveStep: progressiveStep,
    activeStep: activeStep,
    onEvent: handleFooterEvent,
    buttons: {
      leftButton: {
        type: 'back',
        label: backLabel,
        outline: true
      },
      rightButton: {
        type: 'submit',
        label: submitLabel,
        disabled: !submitEnabled
      }
    },
    below: error && errorPosition === 'footer' && /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        margin: '1rem'
      }
    }, /*#__PURE__*/React__default["default"].createElement(index$2["default"], null, /*#__PURE__*/React__default["default"].isValidElement(error) ? error : /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
      langKey: "returnsReviewError"
    })))
  })), submitting && /*#__PURE__*/React__default["default"].createElement(index$4["default"], null, /*#__PURE__*/React__default["default"].createElement(index$5["default"], {
    width: 50
  }), /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, null, /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
    langKey: "returnsReviewSubmittingReturn"
  }))));
};
const ReviewSummaryRaw = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(StyledThemeProvider.withStyledThemeProvider(ReviewSummaryRawC, {
  themeTokens: ['bodytextDefaultNone', 'panelcontainerNoneNone', 'panelcontainerNoneActive', 'panelcontainerNoneHover']
}), {
  translationKeys: ['returnsActionsBack', 'returnsActionsSubmit']
}), {
  settingsRequested: `
      itemDisplay {
        additionalItemAttributeConfig {
          attribute
          value {
            concatKey
            concatPosition
            label
            transform
          }
        }
        itemAttributeConfig
      }
    `
});

exports.ReviewSummaryRaw = ReviewSummaryRaw;
exports.checkIfEmailFieldIsValid = checkIfEmailFieldIsValid;
